import { Grid, Tooltip, Select, MenuItem } from "@mui/material";
import CustomButton from "../components/custom-button-component";
import * as React from 'react';
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Otpverifycompo from "../components/otpverify";
import UserAuth from "../components/userauthenticate";
import { useFormik } from "formik";
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslate } from "react-redux-multilingual";
import { IntlActions } from "react-redux-multilingual";
import supporticon from '../../src/assets/Images/supporticon.png'
import md5 from "md5";
import { UserSignup, returnKey, setInitailLag, setLanguage, setSignUpUser, setUserJson, setVerifyScreenOne, setemailId, setencryptedData } from "../reducers/SignUpReducer";
import getLanguageDetails from "jodo-language-package"
import logo from "../assets/Images/logo_transparent.png"

const SignupPage = ({ }) => {
    let { userjson } = useParams();
    const languageObj = getLanguageDetails("langarr")
    const Confdata = window['runConfig'];
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [callApi, setCallApi] = React.useState(false);
    const [autologin_data, set_autologin_data] = React.useState({});
    const re = /^[A-Za-z\s]+$/;
    const dispatch = useDispatch();
    const t = useTranslate();
    const store = useSelector(state => state);
    const { verifyscreenone,
        signupuser,
        initailLag,
        language, } = store.signup;

    const { EmailId, OTP } = verifyscreenone
    const steps = [t('otpverify'), t('signup')];
    React.useEffect(() => {
        if (userjson !== null && userjson !== "" && userjson !== undefined) {
            const json1 = window.atob(userjson)
            dispatch(setUserJson(JSON.parse(json1)));
        }
    }, [userjson]);

    // get language from localstorage and set to state
    useEffect(() => {
        if (localStorage.getItem("language")) {
            let lang = localStorage.getItem("language");
            dispatch(setLanguage(lang))
            dispatch(setInitailLag(lang))
        }
    }, [])

    const jodosignup = store.signup.language;
    const lang_email = languageObj.find(option => option.languagecode === language).language;
    const data = {
        "emailid": store.signup.userjson.emailid,
        "newpassword": md5(store.signup.signupuser.password),
        "confirmpassword": md5(store.signup.signupuser.confirmpassword),
        "otp": store.signup.verifyscreenone?.OTP,
        "language": lang_email,
    }

    React.useEffect(() => {
        let autologin = {
            "app_name": "Jodo Toolbar",
            "app_url": `${Confdata.apiUrl}/jodotoolbar/`,
            "app_version": "1.2.7.1",
            "app_date": new Date(),
            "app_lang": jodosignup,
            "app_id": "1",
            "login_id": store.signup.userjson.emailid,
            "random_key": store.signup.randomkey,
            "password": store.signup.encryptedPass,
        }

        function base64EncodeUnicode(str) {
            let utf8Bytes = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
                return String.fromCharCode('0x' + p1);
            })
            return window.btoa(utf8Bytes)
        }
        const encryptedData = base64EncodeUnicode(JSON.stringify(autologin))

        set_autologin_data(encryptedData)

        dispatch(UserSignup(data, encryptedData))
    }, [store.signup.randomkey])

    React.useEffect(() => {

        if (store.signup.success === true) {
            setTimeout(() => {
                dispatch(setencryptedData(autologin_data));
            }, 1000)
        }

    }, [store.signup.success])

    let validationSchemaOne = yup.object({
        otp: yup
            .string(t('enterotp'))
            .required(t('otpRequiredValidation'))
            .min(6, t('otpMinLength'))
            .matches(/^[a-zA-Z0-9]*$/, t('otpValidationRegex'))
            .max(6, t('otpMaxLength')),

    });

    let validationSchemaPass = yup.object({
        Password: yup
            .string()
            .required(t('passwordRequired'))
            .max(25, t('twentyFiveCharValidation'))
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, t('passwordRegexValidation')),

        confirmPassword: yup
            .string()
            .when("Password", {
                is: val => (val && val.length > 0 ? true : false),
                then: yup.string().oneOf(
                    [yup.ref("Password")],
                    t('confirmPasswordMatchValidation')
                )
            })
            .max(25, t('twentyFiveCharValidation'))
            .required(t('confirmPasswordRequired')),

    });

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    // use formik for validation
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            otp: ''
        },
        validationSchema: validationSchemaOne,
        onSubmit: (values) => {
            if (steps === 1) {
                dispatch(verifyOTP({
                    otp: values.otp,
                    email: values.email
                }))
            } else {
                dispatch(setVerifyScreenOne({
                    ...verifyscreenone,
                    'EmailId': values.email,
                    'OTP': values.otp
                }))
                const moveToScreen2 = () => {
                    handleNext()
                }
                moveToScreen2()
            }
        }
    })


    const formik_pageTwo = useFormik({
        initialValues: {
            Password: "",
            confirmPassword: "",
        },
        validationSchema: validationSchemaPass,
        onSubmit: (values) => {
            const moveToScreen2 = () => {
                setCallApi(true)
                dispatch(setSignUpUser({
                    ...signupuser,

                    'EmailId': values.email,
                    'password': values.Password,
                    'confirmpassword': values.confirmPassword,
                }))
                const emailId = store.signup.userjson.emailid;
                const md5password = store.signup.encryptedPass;
                const random_key = store.signup.randomkey;

                let autologin = {
                    "app_name": "Jodo Toolbar",
                    "app_url": `${Confdata.apiUrl}/jodotoolbar/`,
                    "app_version": "1.2.7.1",
                    "app_date": new Date(),
                    "app_lang": jodosignup,
                    "app_id": "11",
                    "login_id": store.signup.userjson.emailid,
                    "password": md5password,
                    "random_key": random_key,
                }

                function base64EncodeUnicode(str) {
                    let utf8Bytes = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
                        return String.fromCharCode('0x' + p1);
                    })
                    return window.btoa(utf8Bytes)
                }
                const encryptedData = base64EncodeUnicode(JSON.stringify(autologin))
                dispatch(returnKey(values.Password))
                handleNext()
            }

            moveToScreen2()
        },
    })

    const handleNext = () => {
        let newSkipped = skipped;
        if (activeStep === 0) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setSkipped(newSkipped);
        }
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }
    };

    // for select language
    const handleLanguageChange = (event) => {
        const language = event.target.value;
        dispatch(setInitailLag(language))
        localStorage.setItem("language", language)
        dispatch(IntlActions.setLocale(language))
        dispatch(setLanguage(language));
    }


    return (

        <>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                <img width={'125px'} height={'60px'} src={logo} />
                <a href="https://docs.jodoworld.com/index.php/docs/jodo-bpp-unified-toolbar/jodo-links-use-cases/" target={"_blank"}>
                    <Tooltip title='Need Help'>
                        <img style={{ marginRight: '10px', marginTop: '5px' }} src={supporticon} />
                    </Tooltip>

                </a>
            </div>
            <Grid container flexDirection={'column'} justifyContent={'center'} sx={{ marginTop: '2rem' }}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '20 0' }}>
                    <Box sx={{ width: '62%' }}>
                        <Stepper activeStep={activeStep}>
                            {steps.map((label, index) => {
                                const stepProps = {};
                                const labelProps = {};
                                if (isStepSkipped(index)) {
                                    stepProps.completed = false;
                                }
                                return (
                                    <Step key={label} {...stepProps}>
                                        <StepLabel sx={{ fontFamily: 'Josefin Sans SemiBold' }} {...labelProps}>{label}</StepLabel>
                                    </Step>
                                );
                            })}
                        </Stepper>
                    </Box>
                </div>
                <Grid style={{ display: 'flex' }} className="language-selection">
                    {/*select language dropdown */}
                    <Select
                        value={initailLag}
                        onChange={handleLanguageChange}
                        variant="standard"
                        style={{ width: '250px', textAlign: 'center' }}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: 250, // Set your desired max height here
                                },
                            },
                        }}
                    >
                        {languageObj.map((option) => (
                            <MenuItem key={option.languagecode} value={option.languagecode}>
                                {option.language}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>

                <form autoComplete="off" onSubmit={activeStep === 0 ? formik.handleSubmit : formik_pageTwo.handleSubmit}>
                    {
                        activeStep === 0 ?
                            <Otpverifycompo
                                emailId={store.signup.userjson.emailid}
                                formik={formik}
                                userInfo={formik}
                            />
                            :
                            <UserAuth
                                emailId={store.signup.userjson.emailid}
                                formik={formik_pageTwo}
                                userInfo={formik}
                            />
                    }
                    <Grid container justifyContent={'center'}>
                        <CustomButton
                            padding="5px 13px"
                            margin='10px 20px'
                            fontSize="16px"
                            color='#256EFF'
                            variant="contained"
                            type={"submit"}
                        >
                            {activeStep === steps.length - 1 ? t('finish') : t('next')}
                        </CustomButton>
                    </Grid>
                </form>
            </Grid>
        </>

    )
}


export default SignupPage;